'use client';

import { useTranslations } from 'next-intl';
import { ShippingBox } from 'assets/icons';
import {
  MidPanel,
  MidPanelPhone,
  LeftPanel,
  RightPanel,
} from 'components/shared/BottomBar';
import styles from './BottomBar.module.css';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { PrimaryButton } from 'components/shared/PrimaryButton';
import { DotSpinner } from 'components/shared';
import { productMap_home } from 'content/products/uhHome';
import { useHomeContext } from 'components/uh-home/HomeContext';

export const BottomBar = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  const sctollToOrderSummary = () => {
    const ref = document.getElementById('order-summary-card');
    if (ref) ref.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const {
    uhx,
    store,
    uhxCart,
    goToNextStep,
    checkout,
    displayPrice,
    dueEffectivePrice,
    shippingEstimate,
    isLoading,
  } = useHomeContext();

  const MidPriceSection = (
    <>
      <MidPanel>
        <p className="total-price-single">
          {displayPrice(dueEffectivePrice)}
          <span className="tax-disclaimer">
            {' '}
            {productMap_home?.taxesInclusion[store as ShopifyStore]
              ? '(Tax incl.)'
              : '(Tax excl.)'}
          </span>
        </p>
      </MidPanel>
      <MidPanelPhone onClick={sctollToOrderSummary}>
        <div className="subtitle-text-btn">Total</div>
        <p className="total-price-single">
          {displayPrice(dueEffectivePrice)}
          <span className="tax-disclaimer">
            {' '}
            {productMap_home?.taxesInclusion[store as ShopifyStore]
              ? '(Tax incl.)'
              : '(Tax excl.)'}
          </span>
        </p>
      </MidPanelPhone>
      {/* )} */}
    </>
  );

  return (
    <div className={`${styles.root} u-grid${className ? ` ${className}` : ''}`}>
      <LeftPanel>
        <p className="chat-specialist">
          <ShippingBox />
          {shippingEstimate}
        </p>
      </LeftPanel>

      {/* {RingSelectionClient.size ? MidPriceSection : null} */}
      {MidPriceSection}
      <RightPanel>
        {uhx || uhxCart !== null ? (
          <PrimaryButton
            onClick={checkout}
            disabled={isLoading || !(uhx || uhxCart !== null)}
            aria-busy={isLoading}
            data-buttontype="add to cart"
            data-variantId={
              productMap_home
                ? productMap_home?.variantId[store as ShopifyStore]
                : ''
            }
            data-product="Ultrahuman Home"
          >
            {isLoading ? (
              <DotSpinner color="#000000" />
            ) : (
              t('ring.productSelection.cartSummary.addToCart')
            )}
          </PrimaryButton>
        ) : (
          <PrimaryButton
            onClick={goToNextStep}
            data-buttontype="go to next step"
            data-variantId={
              productMap_home
                ? productMap_home?.variantId[store as ShopifyStore]
                : ''
            }
            data-product="Ultrahuman Home"
          >
            {/* Continue */}
            {t('ring.CONTINUE')}
          </PrimaryButton>
        )}
      </RightPanel>
    </div>
  );
};
